import React, { useEffect, useState, useContext } from "react"
import { Actions as AuthActions } from "./autenticacao/Actions";


export const AuthActionsContext = () => {
    return AuthActions();
};